import './TagAttack.css'

const indexRange:any = {
    'L' : 'LOW',
    'M' : 'MEDIUM',
    'H' : 'HIGH'
}

const checkRange = (value:number):string => {
    if(0.1 <= value && value < 0.8) return 'M';
    if(value >= 0.6) return 'H';
    return 'L';
}

export const getThreatRangeText = (value:number):string =>{
    const v = checkRange(value);
    return indexRange?.[v] || Object.values(indexRange)[0];
}

export default function TagAttack(props:any){
    const v = checkRange(props.value);

    return(
        <div className="zt-tag-attack">
            <div className={`ztt-${v}`}>{v}</div>
        </div>
    )
}